module.exports = __webpack_public_path__ + "static/media/vu.5c33b1e7.svg";